import { server } from "@/api";

export const dashboard = async () => {
    return await server().get('api/portal/dashboard');
}

export const purchased = async () => {
    return await server().get('api/portal/purchased');
}

export const notifications = async () => {
    return await server().get('api/portal/notifications');
}

export const markRead = async (id) => {
    return await server().post(`api/portal/notifications/${id}/read`);
}

export const markAllRead = async () => {
    return await server().post('api/portal/notifications/read-all');
}

export const unreadCount = async () => {
    return await server().get('api/portal/notifications/unread-count');
}

// Support tickets (client)
export const tickets = async () => {
    return await server().get('api/portal/tickets');
}

export const ticket = async (id) => {
    return await server().get(`api/portal/tickets/${id}`);
}

export const createTicket = async (payload) => {
    return await server().post('api/portal/tickets', payload);
}

export const replyTicket = async (id, payload) => {
    return await server().post(`api/portal/tickets/${id}/reply`, payload);
}

export const ticketsUnreadCount = async () => {
    return await server().get('api/portal/tickets/unread-count');
}

export default {
    dashboard, purchased, notifications, markRead, markAllRead, unreadCount,
    tickets, ticket, createTicket, replyTicket, ticketsUnreadCount,
};
